import React, { useState, useEffect, useRef } from 'react';
import useOnClickOutside from '../Hooks/useOnClickOutside';
import clsx from 'clsx';

function DropdownItem({ children, className, ...props }) {    
    return (
        <li {...props}
            className={clsx('dropdown__item', className)}>
            {children}
        </li>
    );
}

function Dropdown({ label, className, children }) {
    const [ isOpen, setIsOpen ] = useState(false);
    const dropdownRef = useRef(null);
    const clickOutsideHandler = useOnClickOutside({
        ref: dropdownRef,
        initialEnabled: false,
        handler: () => setIsOpen(false),
    });

    function onClick(item) {
        setIsOpen(prev => !prev);
    }

    useEffect(() => {
        clickOutsideHandler.toggle(isOpen);
    }, [ isOpen ]);

    return (
        <div ref={dropdownRef}
             className={clsx('dropdown', isOpen && 'dropdown--open', className)}>
            <button onClick={onClick}
                    className="dropdown__button">
                {label}
                <svg xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 512 512"
                     width="1em"
                     height="1em"
                     fill="none"
                     stroke="currentColor"
                     aria-hidden="true"
                     className="dropdown__button-icon">
                    <path d="m112 184 144 144 144-144"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="48" />
                </svg>
            </button>
            {isOpen && (
                <ul className="dropdown__menu">
                    {children}
                </ul>
            )}
        </div>
    );
}

export default Object.assign(Dropdown, {
    Item: DropdownItem,
});